import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileCallBar } from "@/components/MobileCallBar";
import { ServicePage } from "@/components/ServicePage";
import Home from "@/pages/Home";
import Sympathy from "@/pages/Sympathy";
import Occasions from "@/pages/Occasions";
import Seasonal from "@/pages/Seasonal";
import Delivery from "@/pages/Delivery";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import Policies from "@/pages/Policies";
import Journal, { JournalPost } from "@/pages/Journal";
import NotFound from "@/pages/NotFound";
import { HOLIDAYS, JOURNAL_POSTS, OCCASIONS, SERVICE_PAGES, TOWNS } from "@/data/site";

let lenisInstance = null;

function SmoothScroll() {
  const { pathname } = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisInstance = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);

  useEffect(() => {
    if (lenisInstance) {
      lenisInstance.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}

function App() {
  const servicePages = [...OCCASIONS, ...HOLIDAYS, ...TOWNS, ...SERVICE_PAGES];

  return (
    <div className="App min-h-screen bg-ivory">
      <BrowserRouter>
        <SmoothScroll />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sympathy-funeral-flowers" element={<Sympathy />} />
            <Route path="/occasions" element={<Occasions />} />
            <Route path="/seasonal" element={<Seasonal />} />
            <Route path="/flower-delivery" element={<Delivery />} />
            {servicePages.map((p) => (
              <Route key={p.path} path={p.path} element={<ServicePage page={p} />} />
            ))}
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/about" element={<About />} />
            <Route path="/journal" element={<Journal />} />
            {JOURNAL_POSTS.map((p) => (
              <Route key={p.path} path={p.path} element={<JournalPost post={p} />} />
            ))}
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <MobileCallBar />
      </BrowserRouter>
    </div>
  );
}

export default App;
